import { ROLLBACK_URL_PARAM } from '../types';

export function parseRollbackSearchParams(searchParams: URLSearchParams) {
  const previewId = searchParams.get(ROLLBACK_URL_PARAM);
  return { previewId };
}

export type RollbackSearchParams = ReturnType<typeof parseRollbackSearchParams>;
